import { Component } from '@angular/core';
import template from './footer.component.html';
import styles from './footer.component.scss';

@Component({
  selector: 'ola-footer',
  template,
  styles: [styles]
})
export class FooterComponent {
}
